module.exports = __webpack_public_path__ + "img/horizontal_4_7_8019.318ca4c4.png";